
import React from 'react';

interface UpscaleIconProps extends React.SVGProps<SVGSVGElement> {}

const UpscaleIcon: React.FC<UpscaleIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h2.25m13.5 0h2.25a2.25 2.25 0 002.25-2.25V16.5m0-13.5V5.25A2.25 2.25 0 0018.75 3h-2.25m-13.5 0H5.25A2.25 2.25 0 013 5.25v2.25m10.5-7.5h-3v3h3v-3zM12 9h.008v.008H12V9zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 3.375h.008v.008H12v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6M9 15h6" />
  </svg>
);

export default UpscaleIcon;
